import { render, staticRenderFns } from "./StatusLabel.vue?vue&type=template&id=40c30b98"
import script from "./StatusLabel.vue?vue&type=script&lang=ts"
export * from "./StatusLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports